import React from 'react'
import Create from '../crud/create'
import fields from './fields'
import menuItems from './menuItems'

const CreateGroupMember = (props) => {
  return (
    <Create
// @ts-ignore
      title='Add Program Question'
      fields={fields}
      apiPath='admin/program_questions'
      successRedirectPath={resource => `/write-now/program_questions/${resource.id}/edit`}
      buildMenuItems={menuItems}
    />
  )
}

export default CreateGroupMember
